import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IRole } from '@roles/models/IRole';
import { Observable } from 'rxjs';
import { IUserRole } from '@account-users/user/models/UserRole';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  constructor(
    private readonly http: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {}

  getRolesPermissions() {
    return this.http.get<IRole>(
      `${this.apiBaseUrl}configurations/role-permissions`,
    ) as Observable<IRole>;
  }

  getUserRoles() {
    return this.http.get(
      `${this.apiBaseUrl}configurations/roles`,
    ) as Observable<IUserRole[]>;
  }
}
